<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="收费配置" subheading="" />
      <a @click="toModifyConfig" v-if="permissionCodes.indexOf('005003001') !== -1">修改</a>
    </div>
    <form>
      <div>
        <div class="form-line">
          <div class="line-text">收费标准：</div>
          <div v-if="feeType !== '2'">固定定价</div>
          <div v-if="feeType === '2'">阶梯定价</div>
        </div>
      </div>

      <div v-if="feeType !== '2'">
        <div class="form-line">
          <div class="line-text">固定定价(含服务费)：</div>
          <div>{{fixedObj.unitPrice || '0'}}元</div>
        </div>
      </div>

      <div v-if="feeType === '2'" v-for="dataLine in ladderData">
        <div class="form-line">
          <div class="line-text">用电类型：</div>
          <div>{{dataLine.elePayTypeText}}</div>
        </div>
        <div class="form-line">
          <div class="line-text">收费单价：</div>
          <div>{{dataLine.unitPrice || '0'}}元</div>
        </div>
        <div class="form-line">
          <div class="line-text">收费时间：</div>
          <div v-if="dataLine.startTime && dataLine.endTime">{{dataLine.startTime}} - {{dataLine.endTime}}</div>
          <div v-else>无</div>
        </div>
      </div>

      <div>
        <div class="form-line">
          <div class="line-text">服务费单价：</div>
          <div>{{serviceObj.unitPrice || '0'}}元</div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import {errorHandler} from '../../../utils/errorHandler'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import {api} from '../../api/ElectronicManagement'
  import TextTitle from '../../../components/Text/TextTitle'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TextTitle,
      Breadcrumb
    },
    name: 'electronic-config',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用电',
            name: 'electronic-over-view'
          }, {
            value: '收费配置',
          }],
        },
        permissionCodes: '',
        peakObj: {
          elePayType: '1',
          startTime: '',
          endTime: '',
          unitPrice: ''
        },
        valleyObj: {
          elePayType: '2',
          startTime: '',
          endTime: '',
          unitPrice: ''
        },
        flatObj: {
          elePayType: '3',
          startTime: '',
          endTime: '',
          unitPrice: ''
        },
        tipObj: {
          elePayType: '4',
          startTime: '',
          endTime: '',
          unitPrice: ''
        },
        fixedObj: {
          elePayType: '5',
          startTime: '',
          endTime: '',
          unitPrice: '0.0000'
        },

        serviceObj: {
          elePayType: '6',
          startTime: '',
          endTime: '',
          unitPrice: '0.0000'
        },

        feeType: '',
        ladderData: []
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getElectricConfigData()
    },
    methods: {
      toModifyConfig () {
        this.$router.push({
          name: 'electronic-config-modify'
        })
      },
      getElectricConfigData () {
        this.$axios.post(api.getElectricPayConfigList, {})
          .then(res => {
            let data = res.data.data
            if (data) {
              data.map(v => {
                this.feeType = v.feeType
                if (v.elePayType === '5') {
                  this.fixedObj = v
                } else if (v.elePayType === '6') {
                  this.serviceObj = v
                } else {
                  if (v.elePayType === '1') {
                    v.elePayTypeText = '峰电'
                  } else if (v.elePayType === '2') {
                    v.elePayTypeText = '谷电'
                  } else if (v.elePayType === '3') {
                    v.elePayTypeText = '平电'
                  } else if (v.elePayType === '4') {
                    v.elePayTypeText = '尖电'
                  }
                  this.ladderData.push(v)
                }
              })
            }
          })
          .catch(errorHandler('获取收费数据失败'))
      }
    }
  }
</script>

<style scoped>
  .main_right {
    text-align: left;
  }

  .flexBox {
    display: flex;
    justify-content: space-between;
  }

  .flexBox a{
    line-height: 58px;
    margin-right: 40px;
    cursor: pointer;
    color: #00a0e6;
  }
  .flexBox a:hover{
    color: #06b3ff;
  }

  form {
    width: 100%;
    margin: 0 auto;
    text-align: left;
  }
  form > div {
    display: flex;
    justify-content: flex-start;
  }
  form > div >div {
    min-width: 320px;
  }
  .form-title {
    color: #333333;
    font-size: 16px;
    line-height: 28px;
    padding-left: 5px;
    border-left: 3px solid #00a0e6;
  }
  .form-line {
    margin: 20px 0;
    line-height: 24px;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 200px;
    text-align: right;
    display: block;
  }
</style>




// WEBPACK FOOTER //
// src/view/ElectronicManagement/ElectronicConfig/ElectronicConfigCenter.vue